export default __webpack_public_path__ + "static/media/avatar5.8ea4665d.svg";